/**
 * Created by Daniela on 23/01/2017.
 */
import { Injectable } from '@angular/core';

import { apiName, tanquesMovimentacaoApiName, tanquesMovimentacaoAreaApiName } from "./data.service";
import { RestService } from "../../../core/services/rest.service";
import { Tanque, MovimentacaoTanque, MovimentacaoTanqueArea } from "./tanque.model";

@Injectable()
export class TanqueApiService {
    constructor(
        private _restService: RestService
    ) { }

    onPost(object: Tanque, done: any) {
        this._restService.onPost(apiName, object, done);
    }

    onPut(object: Tanque, done: any) {
        this._restService.onPut(apiName, object, done);
    }

    onDelete(objectId: number, done: any) {
        this._restService.onDelete(apiName, objectId, done);
    }

    onGetAll(done: any) {
        let filter: any = {"order":"identificacao","include":["combustivel","local"]};
        this._restService.onGetPost(apiName, filter, done);
    }

    onGetById(objectId: number, done: any) {
        let filter: any = {"include":["local","combustivel"]};
        this._restService.onGetPostId(apiName, objectId, filter, done);
    }

    onGetByLocal(localId: number, done: any) {
        let filter: any = {"order":"identificacao","include":["local","combustivel"],"where":{"localId":localId}};
        this._restService.onGetPost(apiName, filter, done);
    }

    onGetEstoqueByTanque(done: any) {
        this._restService.onGet(apiName + '/relatorio/capacidade-atual', done);
    }

    onGetEstoqueByArea(done: any) {
        this._restService.onGet('areas/relatorio/capacidade-atual-por-combustivel', done);
    }

    onGetEstoqueByOrgao(done: any) {
        this._restService.onGet('orgaos/relatorio/capacidade-atual-por-combustivel', done);
    }

    onGetApiUrl() {
        return apiName;
    }

    //movimentacao
    onPostMovimentacao(object: MovimentacaoTanque, done: any) {
        this._restService.onPost(tanquesMovimentacaoApiName, object, done);
    }

    onPutMovimentacao(object: MovimentacaoTanque, done: any) {
        this._restService.onPut(tanquesMovimentacaoApiName, object, done);
    }

    onGetByMovimentacaoFilter(filter: any, done: any) {
        filter.include = ["bem","combustivel","bomba","area",{"funcionario":"pessoa"},"local","tanque","tanqueDestino","tipoAjuste"];
        this._restService.onGetPost(tanquesMovimentacaoApiName, filter, done);
    }

    onGetByMovimentacaoId(objectId: number, done: any) {
        let filter: any = {"include":["bem","combustivel","bomba","area",{"funcionario":"pessoa"},"local","tanque","tanqueDestino","tipoAjuste"]};
        this._restService.onGetPostId(tanquesMovimentacaoApiName, objectId, filter, done);
    }

    onDeleteMovimentacao(objectId: number, done: any) {
        this._restService.onDelete(tanquesMovimentacaoApiName, objectId, done);
    }

    //movimentacao tanque/area
    onPostMovimentacaoArea(object: MovimentacaoTanqueArea, done: any) {
        this._restService.onPost(tanquesMovimentacaoAreaApiName, object, done);
    }

    onPutMovimentacaoArea(object: MovimentacaoTanqueArea, done: any) {
        this._restService.onPut(tanquesMovimentacaoAreaApiName, object, done);
    }

    onGetByMovimentacaoAreaFilter(filter: any, done: any) {
        filter.include = ["area"];
        this._restService.onGetPost(tanquesMovimentacaoAreaApiName, filter, done);
    }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/abastecimentos/tanques/shared/tanque-api.service.ts
 **/